export interface EventTicketLink {
  /** The first External URL, trimmed. Opened as is: the query string may carry a partner code. */
  url: string;
  /** Hostname without a leading "www.", as shown to people. */
  domain: string;
}

// Same pattern as the backend's `registration_target`: a plain ASCII http(s)://host URL whose
// last label starts with a letter, an optional port, then the end or one of /?#. The browser
// and Python's `urlparse` read the same host from every URL it matches.
const TICKET_URL = /^https?:\/\/((?:[a-z0-9-]+\.)+[a-z][a-z0-9-]*)(?::[0-9]*)?(?:[/?#]|$)/i;

/**
 * The ticket link of an event: its first External URL, and only that one, when it is a plain
 * http(s)://host URL (same pattern as the backend's `registration_target`), so the page, the
 * Going email and the Going sheet all point at the same place. A first entry that does not
 * qualify means there is no ticket link, even if a later entry would.
 */
export function getEventTicketLink(
  externalUrls: readonly string[] | undefined,
): EventTicketLink | null {
  const first = externalUrls?.[0]?.trim();
  const host = first ? TICKET_URL.exec(first)?.[1] : undefined;
  if (!first || !host) return null;
  return { url: first, domain: host.toLowerCase().replace(/^www\./, '') };
}
